const tagTypes = {
    user: "USER",
    bike: "BIKE",
};

export default tagTypes;



// WEBPACK FOOTER //
// ./src/data/tag-types.js